module.exports = __webpack_public_path__ + "static/media/search.f962741c.svg";